import {
  Controller,
  Control,
  FieldValues,
  Path,
  ControllerProps,
} from "react-hook-form";
import { TextField, TextFieldProps } from "@mui/material";

export type FormTextFieldProps<T extends FieldValues> = Omit<
  ControllerProps<T>,
  "render"
> & {
  label: string;
  textFieldProps?: Partial<TextFieldProps>;
};

const FormTextField = <T extends FieldValues>({
  name,
  control,
  label,
  textFieldProps = {},
  rules,
  ...controllerProps
}: FormTextFieldProps<T>) => {
  const isRequired = !!rules?.required;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      {...controllerProps}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          fullWidth
          label={label}
          variant="outlined"
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          value={field.value ?? ""}
          required={isRequired}
          {...textFieldProps}
        />
      )}
    />
  );
};

export default FormTextField;
